import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaWhatsapp,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom"; // Add this import
import { MdEmail, MdPhone } from "react-icons/md";
import "../styles/Advert.css";

const Advert = () => {
  const navigate = useNavigate();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo / About */}
        <div className="footer-section">
          <h3 className="footer-title">HuntexLotto</h3>
          <p className="footer-text">
            Secure and user-friendly electronic lottery platform.
          </p>
          <div className="footer-socials">
            <a href="#">
              <FaFacebookF />
            </a>
            <a href="#">
              <FaTwitter />
            </a>

            <a
              href="https://wa.me/557327038"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp />
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-section">
          <h3 className="footer-title">Quick Links</h3>
          <ul>
            <li>
              <a href="#">About Us</a>
            </li>
            <li>
              <a href="#">How It Works</a>
            </li>
            <li
              style={{
                background: "none",
                border: "none",
                color: "inherit",
                font: "inherit",
                cursor: "pointer",
                padding: 0,
                textDecoration: "underline",
              }}
              onClick={() => navigate("/faqs")}
            >
              <a href="#">FAQs</a>
            </li>
          </ul>
        </div>

        {/* Legal */}
        <div className="footer-section">
          <h3 className="footer-title">Legal</h3>
          <ul>
            <li onClick={() => navigate("/privacy")}>
              <a href="#"> Privacy Policy</a>
            </li>
            <li>
              <a href="#">Terms of Service</a>
            </li>
            <li>
              <a href="#">Pricing</a>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-section">
          <h3 className="footer-title">Contact Us</h3>
          <p>
            <MdEmail className="icon" /> huntexlotto.com@huntexlotto.com
          </p>
          <p>
            <MdPhone className="icon" /> +233 557 327 038
          </p>
          <p>
            <MdPhone className="icon" /> +233 243 209 725
          </p>
        </div>
      </div>

      {/* Bottom */}
      <div className="footer-bottom">
        <p>© 2025 HuntexLotto. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Advert;
